"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutIcon = void 0;
var Preact = __importStar(require("preact"));
var SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
/** Made by opening the svg exported from figma and manually copying the relevant bits into an
 * SvgIcon (and removing fill so it obeys colour setting).
 * Please see https://mui.com/material-ui/icons/#svgicon
 */
function CheckoutIcon(props) {
    return (Preact.h(SvgIcon_1.default, __assign({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props),
        Preact.h("path", { d: "M3.14551 3.00001H2C1.44772 3.00001 1 2.5523 1 2.00001C1 1.44773 1.44772 1.00001 2 1.00001H3.3164C3.32312 1.00001 3.32995 1.00001 3.33688 1.00001C3.43966 0.999965 3.56544 0.999916 3.67745 1.00843C3.80953 1.01846 3.99314 1.04397 4.19022 1.13299C4.44972 1.25021 4.67049 1.43886 4.82674 1.6769C4.94541 1.85768 4.99925 2.03507 5.02976 2.16397C5.05563 2.27328 5.0752 2.39752 5.09119 2.49905C5.09227 2.5059 5.09333 2.51265 5.09438 2.51928L5.48607 5.00001L21.0678 5C21.2087 4.99995 21.3716 4.9999 21.513 5.0122C21.6723 5.02605 21.9111 5.06201 22.153 5.20217C22.459 5.37953 22.6926 5.65936 22.8123 5.99223C22.907 6.25528 22.8996 6.49662 22.8848 6.65585C22.8716 6.79716 22.8424 6.9574 22.8171 7.09607L21.4555 14.5852C21.3758 15.0236 21.3063 15.4056 21.2245 15.7197C21.1375 16.054 21.0203 16.3801 20.8117 16.6868C20.4968 17.1499 20.0586 17.5156 19.5467 17.7426C19.2075 17.8929 18.8658 17.9499 18.5213 17.9758C18.1976 18 17.8094 18 17.3637 18H7.5387L7.85449 20H19C19.5523 20 20 20.4477 20 21C20 21.5523 19.5523 22 19 22L7.6631 22C7.56032 22.0001 7.43455 22.0001 7.32255 21.9916C7.19047 21.9816 7.00686 21.956 6.80977 21.867C6.55028 21.7498 6.32951 21.5612 6.17326 21.3231C6.05459 21.1423 6.00075 20.965 5.97024 20.8361C5.94437 20.7267 5.9248 20.6025 5.90881 20.501L3.14551 3.00001ZM7.22292 16H17.3294C17.8192 16 18.1318 15.9994 18.3716 15.9814C18.5989 15.9643 18.6882 15.9355 18.7361 15.9142C18.9068 15.8386 19.0528 15.7167 19.1578 15.5623C19.1873 15.5189 19.2316 15.4362 19.2891 15.2157C19.3497 14.9829 19.4062 14.6755 19.4939 14.1936L20.8018 7.00001H5.80186L7.22292 16Z" })));
}
exports.CheckoutIcon = CheckoutIcon;
